import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react';
import { Platform, Switch } from 'react-native';

export default function AnnualBillingSwitch({
    value,
    onValueChange,
}: { value: boolean; onValueChange: (value: boolean) => void }) {
    const { i18n } = useLingui();
    return (
        <Switch
            accessibilityLabel={i18n._(msg({ id: 'pricing.billing.annual', message: 'Annual' }))}
            value={value}
            onValueChange={onValueChange}
            trackColor={{ false: '#d1d5db', true: '#9ca3af' }}
            thumbColor={Platform.OS === 'web' ? '#f3f4f6' : '#ffffff'}
            ios_backgroundColor="#d1d5db"
        />
    );
}
